import React, { useEffect, useState } from "react";
import { Button, Menu, Modal } from "antd";
import { Link } from "react-router-dom";
import SidebarLogo from "./SidebarLogo";
import { THEME_TYPE_LITE } from "../../constants/ThemeSetting";
import { useDispatch, useSelector } from "react-redux";
import {
  HomeOutlined,
  LogoutOutlined,
  CommentOutlined,
  ProfileOutlined,
  FileTextOutlined,
  UserOutlined,
  MessageOutlined,
  FileSyncOutlined,
  LoginOutlined,
  GiftOutlined,
  CalculatorOutlined,
  InteractionOutlined,
  CreditCardOutlined,
  ContactsOutlined,
} from "@ant-design/icons";
import {
  isAdminApp,
  isCargoOfferAllowedEmail,
  isCommissionAgent,
  isFreightForwarder,
  isManufacturer,
  isUserApp,
} from "../../util/helper";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  isExporter,
  isBuyer,
  isCHA,
  isShipping,
  isProductApplicable,
  isManufacturerCumExporter,
  isCustomhouseagentsCumFreightforwarder,
} from "./../../util/helper";
import { AUTH_TYPES } from "../../appRedux/types/authTypes";
import "./SidebarContent.css";
import { BUSINESS_TYPE } from "../../util/Constant";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import UpgradeModal from "../Sidebar/upgradeModel"; // Adjust the import path
import LockedIcon from "../../../src/assets/images/material-symbols_lock (1).png";

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const dispatch = useDispatch();
  const { themeType } = useSelector(({ settings }) => settings);
  const pathname = useSelector(({ common }) => common.pathname);
  const userData = useSelector(({ auth }) => auth?.userData);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  useEffect(() => {
    const fetchActiveSubscription = async () => {
      try {
        const response = await axiosInstance.get(
          `/subscription-plans/user/${userData.id}`
        );
        console.log("response", response);

        if (response.data.isActive) {
          // Changed from hasActiveSubscription to isActive
          setSubscriptionData({
            ...response.data,
            daysRemaining: calculateDaysRemaining(
              response.data.subscription.endDate
            ),
          });
        } else {
          setSubscriptionData({
            isActive: false,
            subscription: response.data.subscription || null,
          });
        }
      } catch (error) {
        console.error("Error fetching active subscription:", error);
        setSubscriptionData({
          isActive: false,
          subscription: null,
        });
      }
    };

    const calculateDaysRemaining = (endDate) => {
      const end = new Date(endDate);
      const now = new Date();
      return Math.ceil((end - now) / (1000 * 60 * 60 * 24));
    };

    fetchActiveSubscription();
  }, [userData.id]);

  const hasPaidAccess =
    (subscriptionData?.subscription?.planId === 2 ||
      subscriptionData?.subscription?.planId === 3) &&
    subscriptionData?.isActive;

  const featureAccess = {
    // 'my-products': { requiredPlan: 2 }, // Basic plan or higher
    "exporter-Data": { requiredPlan: 1 }, // Premium plan only
    "chat-message": { requiredPlan: 1 }, // Premium plan or higher
  };

  const checkFeatureAccess = (featureKey) => {
    if (!featureAccess[featureKey]) return true;

    return (
      subscriptionData?.subscription?.planId >=
      featureAccess[featureKey].requiredPlan && subscriptionData?.isActive
    );
  };

  const handleFeatureClick = (featureKey, e) => {
    if (!checkFeatureAccess(featureKey)) {
      e.preventDefault();
      setShowUpgradeModal(true);
    }
  };

  let selectedKeys = pathname.split("/")[1];
  if (selectedKeys === "") {
    selectedKeys = "home";
  }
  const history = useHistory();
  const onLogoutClick = async () => {
    try{
      await axiosInstance.post(
        `${BASE_API_CONFIG.baseURL}/loginsessiondetails/logout/${userData?.id}`
      );
    }catch(error) {
      console.error("Logout session update failed", error);
    };
    dispatch({ type: AUTH_TYPES.LOGOUT_ACTION });
    localStorage.removeItem("token");
    history.replace("/signin");
  };

  const canViewFreightMenus =
  isFreightForwarder(userData) ||
  isCustomhouseagentsCumFreightforwarder(userData);

  const renderUserSideMenu = () => {
    return (
      <>
        <Menu.Item key="home">
          <Link to="/">
            <HomeOutlined />
            <span>Home</span>
          </Link>
        </Menu.Item>
        {isProductApplicable(userData) && (
          <Menu.Item key="products">
            <Link to="/my-products">
              <ProfileOutlined />
              <span>My Products</span>
            </Link>
          </Menu.Item>
        )}
        {!isBuyer(userData) &&
          !isManufacturerCumExporter(userData) &&
          !isCustomhouseagentsCumFreightforwarder(userData) &&
          !isExporter(userData) && (
            <Menu.Item key="enquiries">
              <Link to="/enquiries">
                <FileTextOutlined />
                <span>
                  {isCHA(userData) ||
                    isShipping(userData) ||
                    isExporter(userData)
                    ? "Leads"
                    : "Leads"}
                </span>
              </Link>
            </Menu.Item>
          )}
        {/*  remove this sidebar to go back to the previous flow */}

        {/* {(isExporter(userData) || isManufacturerCumExporter(userData)) &&
          !isCargoOfferAllowedEmail(userData) && (
            <Menu.Item key="cargo-offers-buyer">
              <Link to="/cargo-offers-buyer">
                <FileSyncOutlined />
                <span>Market Watch</span>
              </Link>
            </Menu.Item>
          )} */}
        {/* {(isExporter(userData) || isManufacturerCumExporter(userData)) &&
          !isCargoOfferAllowedEmail(userData) && (
            <Menu.Item key="rfq">
              <Link to="/rfq">
                <FileTextOutlined />
                <span>My RFQ</span>
              </Link>
            </Menu.Item>
          )} */}

        {isManufacturerCumExporter(userData) && (
          <>
            <Menu.SubMenu
              key="exporter-role"
              icon={<FileTextOutlined />}
              title="Exporter Role"
              className="custom-submenu"
            >
              <Menu.Item key="buyer-enquiries">
                <Link to={`/enquiries?role=${BUSINESS_TYPE.BUYER}`}>
                  <FileTextOutlined />
                  <span>Buyer Leads</span>
                </Link>
              </Menu.Item>
              {/* <Menu.Item key="rfq">
                <Link to="/rfq">
                  <FileTextOutlined />
                  <span>My RFQ</span>
                </Link>
              </Menu.Item> */}
              <Menu.Item key="freight-market-watch">
                <Link to="/freight-market-watch">
                  <ProfileOutlined />
                  <span>Instant Freight Rates</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="rfq-freight-rate">
                <Link to="/rfq-freight-rate">
                  <FileTextOutlined />
                  <span>Get Freight Rate(Ocean / Air)</span>   
                </Link>
              </Menu.Item>
              <Menu.Item key="rfq-cha">
                <Link to="/rfq-cha">
                  <FileTextOutlined />
                  <span>Find Your CHA</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="policy-updates">
                <Link to="/policy-updates">
                  <FileSyncOutlined />
                  <span> Exporter Policy Updates </span>
                </Link>
              </Menu.Item>
              <Menu.Item key="business-card-requests">
                <Link to="/business-card-requests-exporter">
                  <CreditCardOutlined />
                  <span>Business Card Requests</span>
                </Link>
              </Menu.Item>
              {/* <Menu.Item key="offer-your-cargo-exporter">
                <Link to="/offer-your-cargo-exporter">
                  <GiftOutlined />
                  <span> Offer Your Cargo </span>
                </Link>
              </Menu.Item> */}
            </Menu.SubMenu>

            <Menu.SubMenu
              key="manufacturer-role"
              icon={<FileTextOutlined />}
              title="Manufacturer Role"
              className="custom-submenu"
            >
              <Menu.Item key="exporter-enquiries">
                <Link to={`/enquiries?role=${BUSINESS_TYPE.EXPORTER}`}>
                  <FileTextOutlined />
                  <span>Exporter Leads</span>
                </Link>
              </Menu.Item>

              {/* <Menu.Item key="offer-your-cargo">
                <Link to="/offer-your-cargo">
                  <GiftOutlined />
                  <span> Offer Your Cargo </span>
                </Link>
              </Menu.Item> */}
            </Menu.SubMenu>
          </>
        )}

        {isCustomhouseagentsCumFreightforwarder(userData) && (
          <>
            {/* <Menu.SubMenu
              key="cha-role"
              icon={<FileTextOutlined />}
              title="Custom House Agents Role"
              className="custom-submenu"
            > */}
            <Menu.Item key="cha-enquiries">
              <Link
                to={`/enquiries?leadType=cha&role=${BUSINESS_TYPE.CUSTOM_HOUSE_AGENT}`}
              >
                <FileTextOutlined />
                <span>CHA Leads</span>
              </Link>
            </Menu.Item>
            {/* </Menu.SubMenu> */}

            {/* <Menu.SubMenu
              key="freightforwarders-role"
              icon={<FileTextOutlined />}
              title="Freight forwarders Role"
              className="custom-submenu"
            > */}
            <Menu.Item key="freight-leads">
              <Link
                to={`/enquiries?leadType=freight&role=${BUSINESS_TYPE.FREIGHT_FORWARDER}`}
              >
                <FileTextOutlined />
                <span>Forwarding Leads</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="freight-market-rate-List">
              <Link to="/freight-market-rate-List">
                <ProfileOutlined />
                <span>Update Freight Rates</span>
              </Link>
            </Menu.Item>
            {/* </Menu.SubMenu> */}
          </>
        )}
        {/* {!isFreightForwarder(userData) && !isBuyer(userData) && (
          <Menu.Item key="chat-message">
            <Link
              to={checkFeatureAccess("chat-message") ? "/chat-message" : "#"}
              onClick={(e) => handleFeatureClick("chat-message", e)}
            >
              <MessageOutlined />
              <span>Messages</span>
              {!checkFeatureAccess("chat-message") && (
                <span className="locked-feature-badge"></span>
              )}
            </Link>
          </Menu.Item>
        )} */}
        {isBuyer(userData) && (
          <>
            <Menu.Item key="cargo-offers-buyer">
              <Link to="/cargo-offers-buyer">
                <FileSyncOutlined />
                <span>Market Watch</span>
              </Link>
            </Menu.Item>

            <Menu.Item key="rfq">
              <Link to="/rfq">
                <FileTextOutlined />
                <span>My RFQ</span>
              </Link>
            </Menu.Item>

            <Menu.Item key="rfq-freight-rate">
              <Link to="/rfq-freight-rate">
                <FileTextOutlined />
                <span>Get Freight Rate (Ocean / Air)</span>
              </Link>
            </Menu.Item>

            <Menu.Item key="Contact Details">
              <Link to="/contact-details">
                <ContactsOutlined />
                <span>Contact Details</span>
              </Link>
            </Menu.Item>

          </>
        )}
        {isExporter(userData) && (
          <Menu.Item key="rfq-freight-rate">
            <Link to="/rfq-freight-rate">
              <FileTextOutlined />
              <span>Get Freight Rate(Ocean / Air)</span>
            </Link>
          </Menu.Item>
        )}

        {/* {isExporter(userData) && (
          <Menu.Item key="source-your-cargo">
            <Link to="/source-your-cargo">
              <FileTextOutlined />
              <span>Source Your Cargo </span>
            </Link>
          </Menu.Item>
        )} */}


        {isExporter(userData) && (
          <Menu.Item key="freight-market-watch">
            <Link to="/freight-market-watch">
              <ProfileOutlined />
              <span>Instant Freight Rates</span>
            </Link>
          </Menu.Item>
        )}

        {isExporter(userData) && (
          <Menu.Item key="rfq-cha">
            <Link to="/rfq-cha">
              <FileTextOutlined />
              <span>Find Your CHA</span>
            </Link>
          </Menu.Item>
        )}
        {isExporter(userData) && (
          <Menu.Item key="business-card-requests">
            <Link to="/business-card-requests-exporter">
              <CreditCardOutlined />
              <span>Business Card Requests</span>
            </Link>
          </Menu.Item>
        )}
        {/* {!isBuyer(userData) && (
          <Menu.Item key="promotions">
            <Link to="/promotions">
              <ProfileOutlined />
              <span>My Promotions</span>
            </Link>
          </Menu.Item>
        )} */}
        {isFreightForwarder(userData) && (
          <Menu.Item key="freight-market-rate-List">
            <Link to="/freight-market-rate-List">
              <ProfileOutlined />
              <span>Update Freight Rates</span>
            </Link>
          </Menu.Item>
        )}

        {(isFreightForwarder(userData) || isCustomhouseagentsCumFreightforwarder(userData)) && (
          <>
            <Menu.Item key="freight-bookings">
              <Link to="/freight-bookings">
                <ProfileOutlined />
                <span>Freight Bookings</span>
              </Link>
            </Menu.Item>

            <Menu.Item key="business-card-requests">
              <Link to="/business-card-requests-freightforwarder">
                <CreditCardOutlined />
                <span>Business Card Requests</span>
              </Link>
            </Menu.Item>
          </>
        )}

        {/* {isExporter(userData) && (
          <Menu.Item key="sellRodtep">
            <Link to="/sell-rodtep">
              <ProfileOutlined />
              <span>Sell RODTEP</span>
            </Link>
          </Menu.Item>
        )}
        {isExporter(userData) && (
        <Menu.Item key="unclaimed-cargo">
            <Link to="/unclaimed-cargo">
              <ProfileOutlined />
              <span>Unclaimed Cargo</span>
            </Link>
          </Menu.Item>
            )} */}
        {/* {isExporter(userData) && (
          <Menu.Item key="exporter-Data">
            <Link
              to={checkFeatureAccess("exporter-Data") ? "/exporter-Data" : "#"}
              onClick={(e) => handleFeatureClick("exporter-Data", e)}
            >
              <ProfileOutlined />
              <span>Exporter Data</span>
              {!checkFeatureAccess("exporter-Data") && (
                <span className="locked-feature-badge">
                  <img
                    src={LockedIcon}
                    alt="Locked"
                    style={{ width: "16px", marginLeft: "8px" }}
                  />
                </span>
              )}
            </Link>
          </Menu.Item>
        )} */}
        {/* {isExporter(userData) && (
          <Menu.Item key="policy-updates">
            <Link to="/policy-updates">
              <FileSyncOutlined />
              <span> Exporter Policy Updates </span>
            </Link>
          </Menu.Item>
        )} */}

        {/* {isExporter(userData) && (
          <Menu.Item key="cargo-offers">
            <Link to="/cargo-offers">
              <FileSyncOutlined />
              <span> Cargo Offers </span>
            </Link>
          </Menu.Item>
        )} */}

        {/* {isExporter(userData) && isCargoOfferAllowedEmail(userData) && (
          <Menu.Item key="offer-your-cargo-exporter">
            <Link to="/offer-your-cargo-exporter">
              <GiftOutlined />
              <span> Offer Your Cargo </span>
            </Link>
          </Menu.Item>
        )} */}

        {/* {(isExporter(userData) || isManufacturerCumExporter(userData)) && (
          <Menu.Item key="price-calculator">
            <Link to="/price-calculator">
              <CalculatorOutlined />
              <span> Price Calculator </span>
            </Link>
          </Menu.Item>
        )} */}

        {(isManufacturer(userData) || isCommissionAgent(userData)) && (
          <Menu.Item key="offer-your-cargo">
            <Link to="/offer-your-cargo">
              <GiftOutlined />
              <span> Offer Your Cargo </span>
            </Link>
          </Menu.Item>
        )}

        <Menu.Item key="logout">
          <Link to="/signin" onClick={onLogoutClick}>
            <LogoutOutlined />
            <span>Logout</span>
          </Link>
        </Menu.Item>
      </>
    );
  };

  const renderAdminSideMenu = () => {
    return (
      <>
        <Menu.Item key="enquiries">
          <Link to="/enquiries">
            <CommentOutlined />
            <span>Enquiries</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="buyer-enquiries">
          <Link to={`/buyer-enquiries?role=${userData?.roles?.name}`}>
            <FileTextOutlined />
            <span>Buyer Leads</span>
          </Link>
        </Menu.Item>

        <Menu.Item key="offer-your-cargo-admin">
            <Link to="/offer-your-cargo-admin">
              <GiftOutlined />
              <span> Offer Your Cargo </span>
            </Link>
        </Menu.Item>

        <Menu.Item key="products">
          <Link to="/products">
            <ProfileOutlined />
            <span>Products</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="users">
          <Link to="/users">
            <UserOutlined />
            <span>Users</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="registrations">
          <Link to="/registrations">
            <HomeOutlined />
            <span>Exporter Registrations</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="website-queries">
          <Link to="/website-queries">
            <HomeOutlined />
            <span>Website Queries</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="promotions">
          <Link to="/promotions">
            <ProfileOutlined />
            <span>Promotions</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="policy-updates">
          <Link to="/policy-updates">
            <FileSyncOutlined />
            <span> Exporter Policy Updates </span>
          </Link>
        </Menu.Item>
        <Menu.Item key="broadcast-promotions">
          <Link to="/broadcast-promotions">
            <ProfileOutlined />
            <span>BroadCast Promotions</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="freight-bookings">
          <Link to="/freight-bookings">
            <ProfileOutlined />
            <span>Freight Booking</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="exporter-port-pair">
          <Link to="exporter-port-pair"></Link>
          <InteractionOutlined />
          <span>Exporter Port Pair</span>
        </Menu.Item>
        <Menu.Item key="navigation-reports">
          <Link to="/navigation-reports">
            <LoginOutlined />
            <span>Login Reports</span>
          </Link>
        </Menu.Item>
      </>
    );
  };

  return (
    <>
      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <div className="gx-sidebar-content">
        {/* <div className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}>
          <UserProfile/>
          <AppsNavigation/>
        </div> */}
        <Menu
          defaultOpenKeys={[selectedKeys]}
          selectedKeys={[selectedKeys]}
          theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
          mode="inline"
        >
          {isUserApp() ? renderUserSideMenu() : null}
          {isAdminApp() ? renderAdminSideMenu() : null}
        </Menu>
      </div>

      <UpgradeModal
        showUpgradeModal={showUpgradeModal}
        // showUpgradeModal={true} // Always show the modal
        setShowUpgradeModal={setShowUpgradeModal}
        history={history} // Pass your history object here
      />
    </>
  );
};

export default React.memo(SidebarContent);
